import { render, staticRenderFns } from "./DraggableScoreTable.vue?vue&type=template&id=3a9b6926&scoped=true"
import script from "./DraggableScoreTable.vue?vue&type=script&lang=js"
export * from "./DraggableScoreTable.vue?vue&type=script&lang=js"
import style0 from "./DraggableScoreTable.vue?vue&type=style&index=0&id=3a9b6926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9b6926",
  null
  
)

export default component.exports